import { Toaster as Sonner } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const theme = "system";
  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-surface-card group-[.toaster]:text-text-primary group-[.toaster]:border-surface-border group-[.toaster]:shadow-lg",
          description:
            "toast-description",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-button-text hover:group-[.toast]:bg-primary-dark",
          cancelButton:
            "group-[.toast]:bg-surface-hover group-[.toast]:text-text-primary hover:group-[.toast]:bg-surface-active",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
